import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b283fbc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-image" }
const _hoisted_2 = { class: "app-info" }
const _hoisted_3 = { class: "app-title mb-0" }
const _hoisted_4 = {
  key: 0,
  class: "small-desc"
}
const _hoisted_5 = {
  key: 1,
  class: "small-desc"
}
const _hoisted_6 = { class: "app-short-description mt-2" }
const _hoisted_7 = { class: "app-buttons" }
const _hoisted_8 = {
  key: 0,
  class: "fa fa-credit-card fa-fw me-1"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Purchase ")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-trash fa-fw me-1" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "app",
    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('open')))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", {
        class: _normalizeClass(_ctx.icon)
      }, null, 2)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.title), 1),
      (_ctx.smallDesc && _ctx.smallDesc instanceof Array)
        ? (_openBlock(), _createElementBlock("small", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.smallDesc, (smallDescLine, idx) => {
              return (_openBlock(), _createElementBlock("div", { key: idx }, _toDisplayString(smallDescLine), 1))
            }), 128))
          ]))
        : (_ctx.smallDesc)
          ? (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString(_ctx.smallDesc), 1))
          : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.description), 1),
      (_ctx.state)
        ? (_openBlock(), _createElementBlock("small", {
            key: 2,
            class: _normalizeClass(["state badge", _ctx.stateClass])
          }, _toDisplayString(_ctx.state), 3))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.labels, (label, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          key: idx,
          class: "badge bg-success me-2"
        }, _toDisplayString(label), 1))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_7, [
      (!_ctx.installed)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('install')), ["stop","prevent"]))
          }, [
            (!_ctx.isBusinessUnitBilling)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8))
              : _createCommentVNode("", true),
            _hoisted_9
          ]))
        : _createCommentVNode("", true),
      (_ctx.installed)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "btn btn-light",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('delete')), ["stop","prevent"]))
          }, _hoisted_11))
        : _createCommentVNode("", true)
    ])
  ]))
}